import { render, staticRenderFns } from "./sentInvoice.vue?vue&type=template&id=634d8341&scoped=true&"
import script from "./sentInvoice.vue?vue&type=script&lang=js&"
export * from "./sentInvoice.vue?vue&type=script&lang=js&"
import style0 from "./sentInvoice.vue?vue&type=style&index=0&id=634d8341&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d8341",
  null
  
)

export default component.exports